import React from "react";
import "./Testimonial.css";

export default function Testimonial() {
  const testimonials = [1, 2, 3, 4];

  return (
    <section className="testimonial-section">
      <div className="container">

        <div className="testimonial-header">
          <span className="line"></span>
          <p>Testimonial</p>
          <span className="line"></span>
        </div>

        <h2 className="testimonial-title">
          What People <span>Say?</span>
        </h2>

        <div className="testimonial-grid">
          {testimonials.map((item, index) => (
            <div className="testimonial-card" key={index}>
              <div className="quote">”</div>
              <p>
                Nobis voluptatem magni doloribus voluptate culpa
                dolor est neque
              </p>
              <h4>Rita O'Conner</h4>
              <span>Sandrine.leutgen@gmail.com</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}